import { type RemovableRef, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

const LEGAL_ENTITY_FILTER_STORAGE_KEY = 'LEGAL_ENTITY_FILTER';

/**
 * Legal entity selected in the global legal entity filter. Shared by all pages with that filter
 * (booking plan, booking list, receivables, ...) and kept across reloads.
 */
export const useLegalEntityFilterStore = defineStore('legalEntityFilterStore', {
  state: () => ({
    legalEntityId: useLocalStorage<string | null>(
      LEGAL_ENTITY_FILTER_STORAGE_KEY,
      null,
    ) as RemovableRef<string | null>,
  }),
  actions: {
    setLegalEntityId(legalEntityId: string | null | undefined) {
      this.legalEntityId = legalEntityId || null;
    },
  },
});
